<template>
  <el-dialog title="关联表单" v-model="oaExamineAssFormVisible" :append-to-body="true" width="1140px" class="dialognewclass dialog-nopadding">
    <div class="oaExamineAssForm" style="overflow: auto;" v-loading="loading" element-loading-text="数据加载中">
        <div class="assFormTop">
          <el-row>
            <template v-if="openAssForm && (openAssForm.selectTable && openAssForm.selectTable === 'customization' && openAssForm.isSource && openAssForm.isSource === 2)">
              <!-- <toolbar v-if="openAssForm.isToolbar"
                       :config="openAssForm"
                      :isFrontEnd="false"
                      :isReport="true"
                      :configComponent="openAssForm"
                      @searchRelevanceConfig="searchRelevanceConfig" /> -->
          </template>
            <template v-else>
              <el-col :span="21">
                <el-row :gutter="20" :class="searchMore?'':'searchRow'" class="searchHei">
                  <el-col :span="6" class="searchList">
                    <el-input v-model="otherSearch.key" size="default" placeholder="搜索标题" @keyup="searchBtn(0)"></el-input>
                  </el-col>
                  <el-col :span="6" v-for="item in query" :key="item.id" class="searchList">
                    <el-select v-model="item.value"
                              :placeholder="'选择'+item.name"
                              @change="searchBtn(0)"
                              multiple collapse-tags
                              size="default" v-if="item.type=='status'"
                              style="width:100%"><!---&&item.checked-->
                      <el-option  label="待审批" value="0"></el-option>
                      <el-option  label="已通过" value="1"></el-option>
                      <el-option  label="未通过" value="2"></el-option>
                      <el-option  label="已撤回" value="3"></el-option>
                    </el-select>
                    <el-date-picker v-model="item.value"
                                    type="daterange"
                                    @change="searchBtn(0)"
                                    size="default" range-separator="至"
                                    format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                    :start-placeholder="item.name + '开始'"
                                    :end-placeholder="item.name + '结束'"
                                    v-if="item.type=='timeof' || item.type === 'dates'" style="width:100%"></el-date-picker>
                    <el-select v-model="item.value"
                              :placeholder="'选择'+item.name"
                              multiple collapse-tags size="default"
                              @change="searchBtn(0)"
                              v-if="item.type=='radio'||item.type=='checkbox'"
                              style="width:100%">
                      <el-option v-for="sels in item.sels" :key="sels.label || sels" :label="sels.label || sels" :value="sels.value || sels"></el-option>
                    </el-select>
                    <el-date-picker v-model="item.value"
                                    type="daterange" size="default"
                                    range-separator="至"
                                    @change="searchBtn(0)"
                                    :start-placeholder="item.name+'开始'"
                                    format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                    :end-placeholder="item.name+'结束'"
                                    v-if="item.type=='date'" style="width:100%"></el-date-picker>
                    <template v-if="item.type=='number'">
                      <el-select v-model="item.value"
                                :placeholder="'选择'+item.name"
                                @change="searchBtn(0)"
                                size="default" style="width:45%">
                        <el-option label="大于等于" value="大于等于"></el-option>
                        <el-option label="小于等于" value="小于等于"></el-option>
                        <el-option label="两者之间" value="两者之间"></el-option>
                      </el-select>
                      <el-input-number v-model="item.min" size="default"
                                      @change="searchBtn(0)"
                                      style="width:25%;" :controls='false'></el-input-number>
                      <el-input-number v-model="item.max"
                                      @change="searchBtn(0)"
                                      size="default" v-if="item.value=='两者之间'"
                                      style="width:25%" :controls='false'></el-input-number>
                    </template>
                  </el-col>
                </el-row>
                <div class="searchMore" v-if="query.length>3" @click="searchMore=!searchMore">
                  <el-icon v-if="searchMore"><CaretTop /></el-icon>
                  <el-icon v-else><CaretBottom /></el-icon>
                </div>
              </el-col>
              <el-col :span="2" class="searchBtn" style="padding-left: 10px;width:100px;display: flex;">
                <p style="margin-bottom: 5px;margin-right:2px;"><el-button type="primary" size="default" @click="searchBtn(0)">搜索</el-button></p>
                <p><el-button size="default" @click="emptyBtn(0)">清空</el-button></p>
              </el-col>
            </template>
          </el-row>
        </div>
        <div class="assFormBox" v-if="tableData">
          <el-table :data="tableData.data"
                    height="420"
                    :stripe="true"
                    :header-cell-style="{ background: '#f8f9fb', color: '#333', fontWeight: 'normal' }"
                    @selection-change="handleSelectionChange"
                    @row-click="rowClick" ref="multipleTable">
            <el-table-column type="selection" width="55" v-if="associatedControlsData.type=='relation-check' || associatedControlsData.isDetail">
            </el-table-column>
             <el-table-column fixed type="index" label="序号" width="60">
             </el-table-column>
             <el-table-column :prop="item.title" v-for="item in tableKey" :key="item.id" :label="item.name">
              <template #default="scope">
                <template v-if="typeof (scope.row[item.title])=='object'&&scope.row[item.title].length!=0">
                  <template v-if="scope.row[item.title].value">
                    <el-popover trigger="hover" placement="top">
                      <template #default>
                        <p style="max-width: 666px">{{scope.row[item.title].value}}</p>
                      </template>
                      <template #reference>
                        <div class="name-wrapper"> {{scope.row[item.title].value}}</div>
                      </template>
                    </el-popover>
                  </template>
                  <template v-for="reldata in scope.row[item.title]" v-else-if="Array.isArray(scope.row[item.title])">
                    <span v-if="reldata.realname!=''" class="reldata-calss" :key="reldata.id">
                      <el-popover trigger="hover" placement="top">
                        <template #default>
                          <p style="max-width: 666px">{{reldata.realname}}</p>
                        </template>
                        <template #reference>
                          <div class="name-wrapper"> {{reldata.realname}}</div>
                        </template>
                      </el-popover>
                    </span>
                  </template>
                  <template v-else>
                    <span v-if="scope.row[item.title].realname!=''" class="reldata-calss">
                      <el-popover trigger="hover" placement="top">
                        <template #default>
                          <p style="max-width: 666px">{{scope.row[item.title].realname}}</p>
                        </template>
                        <template #reference>
                          <div class="name-wrapper"> {{scope.row[item.title].realname}}</div>
                        </template>
                      </el-popover>
                    </span>
                  </template>
                </template>
                <template v-else>
                  <el-popover trigger="hover" placement="top" v-if="scope.row[item.title]">
                    <template #default>
                      <p style="max-width: 666px">
                        {{scope.row[item.title].value||scope.row[item.title].value==''?scope.row[item.title].value:scope.row[item.title]}}
                      </p>
                    </template>
                    <template #reference>
                      <div class="name-wrapper">
                        {{scope.row[item.title].value||scope.row[item.title].value==''?scope.row[item.title].value:scope.row[item.title]}}
                      </div>
                    </template>
                  </el-popover>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <div class="paginationbox">
            <div class="assFormFooter" v-if="associatedControlsData.type=='relation-check' || associatedControlsData.isDetail">
              <el-button type="info" @click="oaExamineAssFormVisible = false" size="default">取 消</el-button>
              <el-button type="primary" size="default" @click="submitBtn()">确 认</el-button>
            </div>
            <el-pagination background
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="tableData.curpage"
                           :page-sizes="[15, 30, 50]"
                           :page-size="tableData.pagesize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="tableData.total"
                           class="pagination"></el-pagination>
          </div>
        </div>
    </div>
  </el-dialog>
</template>

<script>
import { axiosBase } from '../../api/api';
import { getopenreportformlist } from '@/port/clientSide/workbench'
import { apiGetapprovaldashboardpreviewNoDate } from '@/port/admins/instrument'
import { sourceNewRel } from './formFillinPageChild/js/relevancy'
// import toolbar from '@/components/admins/instrument/common/toolbar/index'
import { openapiGetapproval } from '@/port/clientSide/applicationRouting'
import { apiGetapprovalreport } from '@/port/admins/report'

export default {
  name: 'oaExamineAssForm',
  props: ['detailsNum', 'userHide', 'approvalId', 'openAssForm'],
  provide () {
    return {
      allDatasArray: []
    }
  },
  // components: {
  //   toolbar
  // },
  data () {
    return {
      oaExamineAssFormVisible:false,
      associatedControlsData:[],  // 模板数据
      tableKey:[],
      tableData: null,
      multipleSelection:{},
      relCheckArr:[],//关联页码
      selectionDate: [],  //已选中的数据
      allSelectionDate: [], //全部的数据
      loading:true,
      //搜索
      searchMore:false,
      otherSearch:{status:'0,1,2,3',type: 0, curpage: 1, pagesize: 30, cateId: "-1", key: "",all:'1'},
      otherSearch2:{},
      query:[],//搜索列表数据
      OtherResObj:{},//其它参数。OtherObj.importType=1入口类型是发起页面进入relWidDataLook查看权限。

      formdata: null,
      // 工坊的搜索条件数据
      searchFilterReport: [],
      showconfigObj: {}
    }
  },
  methods: {
    searchRelevanceConfig (val) {
      console.log('searchRelevanceConfig', val)
      const ind = this.openAssForm.toolbarConfig.findIndex(its => its && (its.i === val.search.filterId))
      if (ind !== -1) {
        // eslint报错，先注释
        // this.openAssForm.toolbarConfig[ind].value = val.search.value
      }
      const item = JSON.parse(JSON.stringify(this.openAssForm))
      this.getReport({curpage: 1, pagesize: this.otherSearch2.pagesize, item: item})
      // 查找筛选列表是不是有一样的，是的话覆盖下，其中如果值为空，则删掉数据
      // const ind = this.searchFilterReport.findIndex(its => its && (its.filterId === val.search.filterId))
      // console.log('查询ind', ind, val, this.searchFilterReport)
      // if (ind !== -1) {
      //   console.log('是否回来的数据为空', !val.search.value || val.search.value.length === 0, '--', val.search.value)
      //   if (!val.search.value || val.search.value.length === 0) {
      //     this.searchFilterReport.splice(ind, 1)
      //   } else {
      //     const obs = { type: 'filter',
      //                   filterId: val.search.filterId,
      //                   dataconfig: {
      //                     rel: 'and',
      //                     where: [
      //                       {
      //                         field: val.search.title || '',
      //                         relation: val.search.relation,
      //                         value: val.search.value
      //                       }
      //                     ]
      //                   }
      //                 }
      //     this.$set(this.searchFilterReport, ind, obs)
      //   }
      // } else {
      //   if (val.search.value.length > 0) {
      //     // 拼接搜索值
      //     this.searchFilterReport.push({
      //       type: 'filter',
      //       filterId: val.search.filterId,
      //       dataconfig: {
      //         rel: 'and',
      //         where: [
      //           {
      //             field: val.search.title || '',
      //             relation: val.search.relation,
      //             value: val.search.value
      //           }
      //         ]
      //       }
      //     })
      //   }
      // }
      // this.otherSearch.curpage = 1
      // const item = JSON.parse(JSON.stringify(this.openAssForm))
      // item.isToolbar = false

      // this.getReport({curpage: 1, pagesize: this.otherSearch2.pagesize, item: item})
    },
    async oaExamineAssChildMethod(item,OtherObj, formdata, flow){
      console.log("关联单选 or 多选", item,OtherObj, formdata);
      //明细进来的控件里面会多一个 isDetail:true 字段
      if (!item.relFormId || item.relFormId === '') {
        this.$message({
          type: 'error',
          message: '关联表为空，请去表单设计设置'
        })
        return false
      }

      if ((!item.isSource || item.isSource !== 2) && (!item.selectTable || item.selectTable !== 'sys')) {
        // 走一次查询应用自定义字段，做一个匹配
        const apply = await openapiGetapproval({ approvalId: item.relFormId }).catch(err => { console.log(err) })
        if (apply.code === 0 && apply.data && apply.data.showconfig) {
          this.showconfigObj = JSON.parse(apply.data.showconfig)
        }
      }

      // formdata 为结果
      this.formdata = formdata;
      // 流程
      this.flow = flow

      //item数据。
      // OtherObj.valOrNew新旧控件1新控件/0旧控件。
      // OtherObj.relWidDataLook查看权限。1全校数据（审核中、已通过）/2全校数据（已通过）/3 个人数据（审核中、已通过）/4个人数据（已通过）
      this.allSelectionDate = [];
      this.selectionDate = [];
      this.relCheckArr = [];
      this.searchFilterReport = []
      this.OtherResObj = OtherObj;
      if(OtherObj.dataconfig&&OtherObj.condition){
       this.otherSearch.dataconfig=JSON.stringify(OtherObj.dataconfig)
       this.otherSearch.condition = JSON.stringify(OtherObj.condition)
       this.otherSearch2.dataconfig=JSON.stringify(OtherObj.dataconfig)
       this.otherSearch2.condition = JSON.stringify(OtherObj.condition)
      }else{
        delete this.otherSearch.dataconfig
        delete this.otherSearch.condition
        delete this.otherSearch2.dataconfig
        delete this.otherSearch2.condition
      }
      if(OtherObj.relWidDataLook){
        this.otherSearch2.relWidDataLook = OtherObj.relWidDataLook;
        this.otherSearch2.approvalId = item.relFormId;
        this.otherSearch2.curpage = 1;
        this.otherSearch2.pagesize = 30;
      }
      //数据隐藏
      if(item.datahided){
        this.otherSearch2.datahided = item.datahided
      }else {
        this.otherSearch2.datahided = 1;
      }
      if(this.query.length > 0){
        this.emptyBtn(0); // 清空搜索记录
      }
      this.query = [];
      this.associatedControlsData = item;
      // 如果是工坊
      if (item.selectTable && item.selectTable === 'customization' && item.isSource && item.isSource === 2) {
        console.log('去工坊查询')
        // 去查询工坊值
        this.getReport({curpage: 1, pagesize: 30, item: item})
        this.oaExamineAssFormVisible=true;
        return
      }
      //这里是去除condition的dataconfig
      const param = {
        curpage:0,
        pagesize:0,
        approvalId:item.relFormId,
        permission:1,
        appid:this.$route.query.approvalId || this.approvalId,
        title:item.title,
      };
      if (this.$route.query.space || this.$route.query.spaceid) {
        param.spaceid = this.$route.query.spaceid || localStorage.getItem('spaceid')
      }
      else if (this.$route.query.upace || this.$route.query.upaceid) {
        param.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
      }
      getopenreportformlist(param).then(res => {
        if(res&&res.code==0){
           res.data.forEach(e => {
             console.log("yyuuuuu===",JSON.stringify(e));
             if(!e.userId){
               //this.tableKey = JSON.parse(e.userReport.content);
               if (item.type === 'relation-check') {
                const tableKey = item.list.map(its => {
                  return {
                    checked: true,
                    name: its.name,
                    title: its.titleId,
                    title1: its.title,
                    type: its.type
                  }
                })
                // this.$set(this, 'tableKey', tableKey)
                this.tableKey = tableKey
               } else {
                this.tableKey = [];
                JSON.parse(e.userReport.content).forEach(el4=>{
                  if(el4.type!='details' && el4.title !== '自定义标题'){
                  this.tableKey.push(el4);
                  }
                });
               }
               this.otherSearch.reportFormId = e.reportFormId;
               this.getfielddatalist();
               if(typeof (e.query)=='string'){
                 e.query = JSON.parse(e.query);
               }
               console.log("res=="+JSON.stringify(e.query));
               e.query.forEach(e2 => {
                console.log("item15==" + JSON.stringify(e2));
                if (e2.checked) {
                  if (e2.type == 'radio' || e2.type == 'checkbox') {
                    if (typeof e2.sels == "string") {
                      e2.sels = JSON.parse(e2.sels)
                    }
                    // this.$set(e2, 'value', []); // Vue2写法，Vue3可直接赋值
                    e2.value = [];
                  } else if (e2.type == 'status') {
                    // this.$set(e2, 'value', []); // Vue2写法，Vue3可直接赋值
                    e2.value = [];
                  } else if (e2.type == 'data') {
                    // ...
                  }
                  this.query.push(e2)
                }
              });
             }
           });
           console.log('this.tableKey=='+JSON.stringify(this.tableKey));
           this.oaExamineAssFormVisible=true;
         }
      }).catch(err => {
        console.log('短信验证错误', err)
      })
      this.oaExamineAssFormVisible=true;
    },
    async getReport ({curpage, pagesize, item}) {
        // 去查询工坊值
        this.loading = true;
        const re = await apiGetapprovalreport({ approvalReportId: item.relFormId }).catch(err => { console.log(err) })
        let list = []
        if (re.code === 0) {
          const source = JSON.parse(re.data.config)
          const sourceInd = source.findIndex(it => it.type === 'output')
          list = source[sourceInd].datas || []
        }
        console.log('工坊搜索配置', item)
        const config = JSON.parse(JSON.stringify(sourceNewRel(item, item.isToolbar ? item.toolbarConfig || [] : [], 'titleId', list, this.formdata, this.flow, true)))
        // const config = JSON.parse(JSON.stringify(sourceSearch(item, this.searchFilterReport, 'titleId')))
        console.log('工坊拼接数据', config)
        // return
        if (item.isToolbar && config.length > 1) {
          this.searchFilterReport = JSON.parse(JSON.stringify(config.slice(1, config.length)))
        }
        apiGetapprovaldashboardpreviewNoDate({
          curpage: curpage,
          pagesize: pagesize,
          config: config.map(its => { if(its.filterId) delete its.filterId; return its }),
          nodeId: config[config.length- 1].id
        }).then(res => {
          console.log('工坊值查询返回', JSON.parse(JSON.stringify(res)))
          if (res.code === 0) {
            const listObj = {}
            const tableKey = item.list.map(its => {
              const sName = its.titleId.split('.')
                listObj[sName[0]] = this.tObj(sName.slice(1), listObj[sName[0]] ? listObj[sName[0]] : {}, its.titleId)
                console.log("兼容值", sName, JSON.parse(JSON.stringify(listObj)), its, its.titleId)
                const obs = {
                checked: true,
                name: its.name,
                // title: its.title,
                title: its.titleId,
                title1: its.title,
                type: its.type
              }
              return obs
            })
            // this.$set(this, 'tableKey', tableKey)
            this.tableKey = tableKey
            res.data = res.data.map(its => {
              its.approvingId = this.approvalId
              its = this.sObj(its, listObj)
              // 转码下数据
              for (const i of tableKey) {
                if (i.title !== i.name) its[i.name] = its[i.title]
                its[i.title] = its[i.name]
              }
              return its
            })
            console.log('查结构', res.data, tableKey, listObj)
            // this.$set(this, 'tableData', res)
            this.tableData = res
          }
          this.loading = false;
        }).catch(err => { console.log('查询错误', err) })
    },
    // 扁平化数据
    sObj (val, config) {
      for (const i in val) {
        if (typeof val[i] === 'object' && typeof config[i] === 'object') {
          // console.log('扁平数据格式', val[i])
          val = {
            ...this.sObj(val[i], config[i]),
            ...val
          }
        } else {
          // console.log('最终赋值', val[i], i, val)
          val[config[i]] = val[i]
        }
      }
      return val
    },
    // 做返回结构
    tObj (arr, obj, value) {
      if (!arr || arr.length === 0) return value
      const key = arr[0]
      obj[key] = arr.length > 1 ? this.tObj(arr.slice(1), {}, value) : value
      return obj
    },
    handleSelectionChange(val){
      console.log('获取选中数据', val)
      if (val) {
        const ArrIs = this.relCheckArr.indexOf(this.otherSearch.curpage);
        if(ArrIs===-1){
          this.relCheckArr.push(this.otherSearch.curpage);
        }
        this.multipleSelection[this.otherSearch.curpage] = val;

        //已选中的
        this.selectionDate = val;
      }
    },
    handleSizeChange(item){
      console.log('handleSizeChange', item)
     this.otherSearch.pagesize=item;
     this.otherSearch2.pagesize=item;
     if (this.openAssForm.selectTable && this.openAssForm.selectTable === 'customization' && this.openAssForm.isSource && this.openAssForm.isSource === 2) {
      const item = JSON.parse(JSON.stringify(this.openAssForm))
      item.isToolbar = false
      this.getReport({curpage: this.otherSearch.curpage, pagesize: this.otherSearch2.pagesize, item: item})
     } else {
      this.getfielddatalist();
     }
    },
    handleCurrentChange(item){
      console.log('handleCurrentChange', item)
      this.otherSearch.curpage=item;
      this.otherSearch2.curpage=item;
      if (this.openAssForm.selectTable && this.openAssForm.selectTable === 'customization' && this.openAssForm.isSource && this.openAssForm.isSource === 2) {
        const item = JSON.parse(JSON.stringify(this.openAssForm))
        item.isToolbar = false
        this.getReport({curpage: this.otherSearch.curpage, pagesize: this.otherSearch2.pagesize, item: item})
      } else {
        this.getfielddatalist();
      }
    },
    //清空已有的数据
    emptyRelWidgetData(relData){
      relData.list.forEach((res)=>{
        if(res.type=='checkbox'){
          res.bindinf=[];
        }else if(res.type=='number'){
          res.defaultValue = ''
        }else if(res.type=='relation-user'){
          // this.$set(res,'bindinf',[]);
          res.bindinf = []
        }else{
          res.bindinf = '';
        }
      })
    },
    rowClick(item){
      console.log('点击确定回去', item, this.associatedControlsData.type === 'relation-check' || this.associatedControlsData.isDetail)
      //选中切换
      if (this.associatedControlsData.type === 'relation-check' || this.associatedControlsData.isDetail) {
        this.$refs.multipleTable.toggleRowSelection(item);
      } else {
        // let newOldVal = 'title';
        // if(this.OtherResObj.valOrNew==1){
        //   newOldVal = 'titleId';
        // }
        const associatedControlsData = this.associatedControlsData;
        if(associatedControlsData.type=="relation-radio"||associatedControlsData.type=="new-rel-radio"){

          console.log('赋值', item, associatedControlsData);

          //清空已有的数据
/*
          this.emptyRelWidgetData(associatedControlsData);
          for(var l in item) {
            if (l == '自定义标题') {
              associatedControlsData.bindinf = item[l];
            }
          }
          associatedControlsData.approvingId = item.approvingId;
*/

          // 赋值自己
          let thisType = associatedControlsData.title + '_' + associatedControlsData.type;
          if (item.自定义标题) this.formdata[thisType] = item.自定义标题;

          // console.log("item1item5=="+JSON.stringify(item));
          // console.log("item1item6=="+JSON.stringify(associatedControlsData));

          const isSource = this.openAssForm.selectTable && this.openAssForm.selectTable === 'customization' && this.openAssForm.isSource && this.openAssForm.isSource === 2
          console.log('判断是否', isSource, thisType)
          if ((associatedControlsData.type=="relation-radio"||associatedControlsData.type=="new-rel-radio") && isSource) {
            const ztype = this.openAssForm.list[0].name
            console.log('判断是否1', item[ztype], ztype, item)
            // this.$set(this.formdata, thisType, item[ztype])
            this.formdata[thisType] = item[ztype]
          }
          associatedControlsData.list.forEach(e => {//遍历关联控件原有数据

            // 赋值
            if (e.type === 'checkbox' || e.type === 'relation-user') {
              let checkboxVal = [];
              try{
                checkboxVal = JSON.parse(isSource ? item[e.name] : item[e.titleId]);
              }
              catch (se) {
                console.log('多选报错', se);
                checkboxVal = isSource ? item[e.name] : item[e.titleId];
              }

              if (typeof checkboxVal === 'string') {
                try{
                  checkboxVal = (isSource ? item[e.name] : item[e.titleId]).split(',');
                }
                catch (e) {
                  console.log('转格式错误')
                }

              }
              console.log('复制1', checkboxVal)
              // this.$set(this.formdata, e.title + '_' + e.type, checkboxVal)
              this.formdata[e.title + '_' + e.type] = checkboxVal;
            } else {
              console.log('复制2', item[e.titleId], item, e.titleId, e)
              // this.$set(this.formdata, e.title + '_' + e.type, isSource ? item[e.name] : item[e.titleId])
              this.formdata[e.title + '_' + e.type] = isSource ? item[e.name] : item[e.titleId];
            }
            // this.$emit('retDate',null, e,0)
          });

          // 如果是联系人控件 并且需要记取隐藏
          if (associatedControlsData.type === 'new-rel-radio' && associatedControlsData.datahided === 2) {
            // eslint报错，先注释
            // let date = {
            //   title: associatedControlsData.title,
            //   linkedApprovingId: item.approvingId
            // };
            // eslint报错，先注释
            // this.userHide[associatedControlsData.title] = date;
          }
          this.oaExamineAssFormVisible=false;
          // 点击确认回去触发联动(这里需要返回对应模板的结构数据)
          this.$emit('newRetDate', this.openAssForm.list)
        }
      }
    },
    dateGoRepeat (data, val) {
      let dataS = JSON.parse(JSON.stringify(data));
      for (let i in val) {
        let index = data.findIndex(item => {return item.approvingId === val[i].approvingId});
        if (index === -1) {
          dataS.push(val[i]);
        }
      }
      return dataS;
    },
    getfielddatalist(){
      this.allSelectionDate = this.dateGoRepeat(this.allSelectionDate, this.selectionDate);
      this.tableData = null;
      let params = this.otherSearch;
      let url = "";
      if(this.OtherResObj.relWidDataLook){
        params = this.otherSearch2;
        params.appid = this.$route.query.approvalId || this.approvalId;

        // 以下两个是后台说的固定参数
        params.type = 0;
        params.cateId = -1;
        url = "/api/getreportdatalist";
      }
      axiosBase(params,url ).then(res => {
        this.loading = false;
        if(res&&res.code==0){
          
          if (this.showconfigObj) {
            res.data = res.data.map(it => {
              for (const i in this.showconfigObj) {
                const ii = this.showconfigObj[i]
                if (it[i]) it[ii] = it[i]
              }
              return it
            })
          }
          this.tableData = res;
          this.assignment(res.data, this.allSelectionDate);
        }
      });
    },
    assignment (val, date) {
      this.$nextTick(() => {
        for (let i in val) {
          let len = date.findIndex(item => {return val[i].approvingId === item.approvingId});
          if (len !== -1) {
            this.$refs.multipleTable.toggleRowSelection(val[i], true);
          }
        }
      })
    },
    submitBtn(){
      //这个是明细单选的逻辑
      if (this.associatedControlsData.isDetail && this.associatedControlsData.type === 'new-rel-radio') {
        let arr = [];
        for (let i in this.multipleSelection) {
          arr = arr.concat(this.multipleSelection[i]);
        }
        //判断是否符合条数
        if (this.detailsNum && this.detailsNum < Number(arr.length)) {
          this.$message({
            type: 'error',
            message: '最多只能选择' + this.detailsNum + '条'
          });
          return false;
        }
        this.$emit('momnewrelradio', arr);
        this.oaExamineAssFormVisible=false;
        return false;
      }
      this.allSelectionDate = this.dateGoRepeat(this.allSelectionDate, this.selectionDate);

      // 值
      console.log('zh', this.formdata, this.allSelectionDate)

      let str = JSON.parse(JSON.stringify(this.allSelectionDate)).map(val => {return val.自定义标题;});
      let strs = str.filter(val => {return val});

      let type = this.associatedControlsData.title + '_' + this.associatedControlsData.type;
      console.log('多选确认', str, strs, type, this.allSelectionDate)
      // 关联多选新结构
      const top = []
      const topData = []
      for (const i of this.tableKey) {
        top.push({name: i.name, title: i.title1})
        for (const [ie, el] of (this.allSelectionDate || []).entries()) {
          if (!topData[ie]) topData[ie] = {}
          topData[ie][i.title1 || i.title] = el[i.title]
        }
      }
      const tableCheck = {
        top: top,
        data: topData
      }
      this.formdata[type] = JSON.parse(JSON.stringify(tableCheck))
      // this.formdata[type] = strs.join(',');
      this.oaExamineAssFormVisible = false;
      this.allSelectionDate = [];
    },
    searchBtn(key){
      var query={};
      this.query.forEach(e =>{
        if(e.value&&e.value!=''&&e.value.length>0){
          if(e.type=='number'){
            var value = []
            if(e.value=='小于等于'){
              value=['',e.min]
            }else if(e.value=='大于等于'){
              value = [e.min,'']
            }else{
              value = [e.min,e.max]
            }
            // this.$set(query,e.title+'_'+e.type,value);
            query[e.title+'_'+e.type] = value
          }else{
            // this.$set(query,e.title+'_'+e.type,e.value);
            query[e.title+'_'+e.type] = e.value
          }
        }
      })
      if(key==0){
        this.otherSearch.query=JSON.stringify(query);
        this.otherSearch2.query=JSON.stringify(query);
        this.switClick();
      }
    },
    switClick(){
      let params = this.otherSearch;
      let url = "";
      if(this.OtherResObj.relWidDataLook){
        params = JSON.parse(JSON.stringify(this.otherSearch2));
        params.key =  this.otherSearch.key;
        params.query =  this.otherSearch.query;
        params.appid = this.$route.query.approvalId || this.approvalId;

        // 以下两个是后台说的固定参数
        params.type = 0;
        params.cateId = -1;
        url = "/api/getreportdatalist";
      }
      axiosBase(params, url).then(res => {
        if(res&&res.code==0){
          if (this.showconfigObj) {
            res.data = res.data.map(it => {
              for (const i in this.showconfigObj) {
                const ii = this.showconfigObj[i]
                if (it[i]) it[ii] = it[i]
              }
              return it
            })
          }
          this.tableData = res;
        }
      });
    },
    emptyBtn(){
      var query={}
      this.query.forEach(e =>{
        // this.$set(e,'value',[]);
        e.value = []
        if(e.type=='number'){
          // this.$set(e,'value','');
          e.value = ''
          e.min=''
          e.max=''
        }
      })
      this.otherSearch.query=JSON.stringify(query);
      this.otherSearch.type=0;
      this.otherSearch.curpage=1;
      this.otherSearch.pagesize=30;
      this.otherSearch.cateId='-1';
      this.otherSearch.key='';
      this.otherSearch.all='1';
      //新控件
      this.otherSearch2.query=JSON.stringify(query);
      this.otherSearch2.key='';
      this.otherSearch2.curpage=1;
      this.otherSearch2.pagesize= 30;
      this.switClick();
    },
  },
	mounted() {
    // this.getdataList();
	},
  watch:{
    'otherSearch.curpage'(){
      setTimeout(()=>{
        if(this.associatedControlsData.type=='relation-check'){
          const curpage = this.otherSearch.curpage;
          if(this.multipleSelection[curpage]){
            this.multipleSelection[curpage].forEach(row=>{
              this.tableData.data.forEach((row2)=>{
                if(row.approvingId == row2.approvingId){
                  this.$refs.multipleTable.toggleRowSelection(row2,true);
                }
              });
            });
          }
        }
      },1500);
    }
  }
}
</script>
<style scoped lang="scss">
.dialognewclass {
  .el-dialog__header {
    background: #f2f2f2;
    height: 45px;
    line-height: 45px;
    padding: 0 20px;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-table {
    .el-table__cell {
      padding: 5px 0;
    }
  }
  .dialog-footer {
    border-top: 1px solid #e5e5e5;
    .el-button {
      border-right: 1px solid #e5e5e5;
      width: 100%;
      border-radius: 0;
    }
  }
}
 .oaExamineAssForm{padding:20px}
 .assFormBox{
  overflow: hidden;
  // padding-bottom: 76px;
}
 .paginationbox{
  // position: absolute;
  position: relative;
  // bottom: 0;
  z-index: 11;
  background: #fff;
  // width: 90%;
  left: 0;
  // padding:4px 5%;
}
 .pagination{float:right;padding:10px 0;}
 .assFormFooter{text-align: center;padding:10px 0 0;}
 .assFormFooter .el-button--medium.is-round{padding:10px 30px}
 .searchList .el-input__icon{cursor: pointer;}
 .reldata-calss:after{
   content: ',';
 }
 .reldata-calss:last-child:after{
   content: '';
 }
 /*分割*/
 .searchHei>div{
   height: 40px;
 }
 .searchRow{height:40px;overflow: hidden;}
 .searchMore{text-align:center;font-size:20px;color:#4e86ff;}
 .searchMore i{cursor: pointer;}
</style>
